import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[disableMouseWheel]',
})
export class DisableMouseWheelDirective {
  @HostListener('wheel', ['$event'])
  onWheel(event: Event) {
    event.preventDefault();
  }
}
